module.exports = __webpack_public_path__ + "img/brett-mulder.0604094b.png";